import DOMPurify from 'dompurify'

const policyName = window.trusted_type?.[0];

if (window.trustedTypes && window.trustedTypes.createPolicy) {
  window.trustedTypes.createPolicy('default', {
    createHTML: (string) => {
      return DOMPurify.sanitize(string, {RETURN_TRUSTED_TYPE: true})
    },
    createScript: (string) => string,
    createScriptURL: (string) => string
  })
}

const policy = window.trustedTypes && window.trustedTypes.createPolicy ? window.trustedTypes.createPolicy(policyName, {
  createHTML: (string) => {
    return DOMPurify.sanitize(string, {RETURN_TRUSTED_TYPE: true})
  },
  createScript: (string) => string,
  createScriptURL: (string) => string
}) : null;

function createHtml (str) {
  return policy ? policy.createHTML(str) : str
}

function createScript (str) {
  return policy ? policy.createScript(str) : str
}

function createScriptURL (str) {
  return policy ? policy.createScriptURL(str) : str;
}

export {
  createHtml,
  createScript,
  createScriptURL,
}

export default policy
